<template>
  <div class="image-translate-container p-6">
    <div
      class="drop-zone"
      :class="{ 'drop-zone--dragging': isDragging, 'drop-zone--filled': previewUrl }"
      @dragover.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      @drop.prevent="onDrop"
      @click="onZoneClick"
    >
      <template v-if="!previewUrl">
        <feather-icon icon="UploadCloudIcon" size="48" style="color: #9CA3AF;" />
        <p class="mt-3" style="color: #6B7280;">{{ $t('이미지를 이곳에 드래그하거나 클릭해서 업로드') }}</p>
        <p class="text-sm mt-1" style="color: #9CA3AF;">JPG, PNG, GIF, WEBP</p>
      </template>
      <template v-else>
        <img :src="previewUrl" class="preview-img" alt="preview" />
      </template>
    </div>

    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display: none;"
      @change="onFileChange"
    />

    <div class="mt-4 flex justify-center gap-3">
      <button v-if="!previewUrl" class="upload-btn" @click="triggerFileInput">
        <feather-icon icon="ImageIcon" class="mr-2" />
        {{ $t('파일 선택') }}
      </button>
      <button v-else class="upload-btn upload-btn--secondary" @click="resetImage">
        {{ $t('다시 선택') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageTranslate',
  data() {
    return {
      isDragging: false,
      previewUrl: null,
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onZoneClick() {
      if (!this.previewUrl) {
        this.triggerFileInput();
      }
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleFile(file);
      }
    },
    onDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.handleFile(file);
      }
    },
    handleFile(file) {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
      }
      this.previewUrl = URL.createObjectURL(file);
      this.$emit('success', file);
    },
    resetImage() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
      this.$refs.fileInput.value = '';
    },
  },
  beforeDestroy() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  }
}
</script>

<style scoped>
.image-translate-container {
  min-width: 360px;
}

.drop-zone {
  border: 2px dashed #D1D5DB;
  border-radius: 12px;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  padding: 24px;
  text-align: center;
}

.drop-zone--dragging {
  border-color: #758AF5;
  background-color: #F0F4FF;
}

.drop-zone--filled {
  cursor: default;
  border-color: #D1D5DB;
  padding: 8px;
}

.preview-img {
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  object-fit: contain;
}

.upload-btn {
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  background-color: #758AF5;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
}

.upload-btn--secondary {
  background-color: #9CA3AF;
}
</style>
